import {Card, CardActionArea, CardContent, CardHeader} from "@mui/material";
import {ApplicationUserGroup} from "./ApplicationUserGroup";
import Typography from "@mui/material/Typography";
import React from "react";
import {useTranslation} from "react-i18next";

export function ApplicationUserGroupCard(props: {
  userGroup: ApplicationUserGroup,
  handleSelectUserGroup: (userGroup: ApplicationUserGroup) => void,
}) {
  const {t} = useTranslation();

  return (
    <Card variant={"outlined"}>
      <CardActionArea onClick={() => props.handleSelectUserGroup(props.userGroup)}>
        <CardHeader title={props.userGroup.name}/>
        <CardContent>
          <Typography variant="body2" color="textPrimary" component="p" style={{opacity: 0.5}}>
            {props.userGroup.amountOfUsers + " " + t("ApplicationUserGroup.amountOfUsers")}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
